import { render, staticRenderFns } from "./ListarItemCredenciamentoHeaderBarraBotoes.vue?vue&type=template&id=9ded04ec&scoped=true"
import script from "./ListarItemCredenciamentoHeaderBarraBotoes.vue?vue&type=script&lang=js"
export * from "./ListarItemCredenciamentoHeaderBarraBotoes.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9ded04ec",
  null
  
)

export default component.exports